import { useLocation } from 'react-router-dom'

export const useWebViewModal = () => {
  const location = useLocation()

  return location ? location.pathname.includes('/trip-planner/webView') : false
}
